export const TipoProdutoStatus = [
  { label: 'Rascunho', value: 'DRAFT' },
  { label: 'Publicado', value: 'PUBLISHED' },
  { label: 'Não publicado', value: 'UNPUBLISHED' }];

export default TipoProdutoStatus;
